export enum DocumentTypesList {
  AdditionalInformationFax = 'Additional Information Fax',
  ApprovalLetter = 'Approval Letter',
  AuthorizationFax = 'Authorization Fax',
  DenialNotification = 'Denial Notification',
  DENCLetter = 'Detailed Explanation of Non-Coverage',
  DismissalLetter = 'Dismissal Letter',
  ExpeditedGrievanceLetter = 'Expedited Grievance Letter',
  IDNLetter = 'IDN Letter',
  SNFLetter = 'SNF Benefit Exhaustion Letter',
  DenialLetter = 'Denial Letter',
  AuthorizationLetter = 'Authorization Fax',
  AdditionalInformationLetter = 'Additional Information Fax',
  NOMNC = 'NOMNC',
  Approval = 'Approval Letter',
  ExpeditedGrievance = 'Expedited Grievance Letter',
  ITDDenialNotification = 'ITD/Denial Notification',
  DenialSpanish = 'Denial Letter - Spanish',
  ApprovalSpanish = 'Approval Letter - Spanish',
  ExpeditedGrievanceSpanish = 'Expedited Grievance Letter - Spanish',
  NOMNCSpanish = 'NOMNC - Spanish',
  DENC = 'DENC',
  DENCSpanish = 'DENC - Spanish',
  P2POffer = 'P2P Offer',
  SPT = 'Service Provider Termination',
  Dismissal = 'Dismissal Letter',
  DismissalNoAor = 'Dismissal No AOR Letter',
  ProviderDenialContracted = 'Provider Denial Contracted Letter',
  SNFBenefitExhaustionLetter = 'SNF Benefit Exhaustion Letter',
  ProviderDenialNonContracted = 'Provider Denial Non-Contracted Letter',
  FacilityDenialNotification = 'Facility Denial Notification',
  MemberOnlyNOMNCfax ="Member Only NOMNC fax",
  AdverseBenefitDeterminationLetter = 'Adverse Benefit Determination Letter',
  DecisionTimeframeExtensionLetter = 'Decision Timeframe Extension Letter',
  PartialDenialLetter = 'Partial Denial Letter',
  OONApprovalLeter = 'OON Approval Letter',
  ReOpenedApprovalLetter = 'Reopened Approval Letter',
  WrittenAcknowledgementFax = "Written Acknowledgement Fax",
  NOMNCRescind = 'NOMNC Rescind'
}
